import React from 'react';

interface ProjectProps {
  className?: string;
  width?: number;
  height?: number;
}

const ProjectIcon = function ProjectIcon({
  className,
  width,
  height,
}: ProjectProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <path d="M25.3334 17.3333V22C25.3334 24.8284 25.3334 26.2426 24.4547 27.1213C23.5761 28 22.1618 28 19.3334 28H12.6667C9.83832 28 8.42411 28 7.54543 27.1213C6.66675 26.2426 6.66675 24.8284 6.66675 22V10C6.66675 7.17157 6.66675 5.75736 7.54543 4.87868C8.42411 4 9.83832 4 12.6667 4H16.0001" stroke="white" strokeLinecap="round" />
      <rect x="6.66675" y="4" width="18.6667" height="24" rx="3.5" fill="#28364C" />
      <path d="M30.1666 7.9987C30.1666 11.4045 27.4057 14.1654 23.9999 14.1654C20.5942 14.1654 17.8333 11.4045 17.8333 7.9987C17.8333 4.59294 20.5942 1.83203 23.9999 1.83203C27.4057 1.83203 30.1666 4.59294 30.1666 7.9987Z" fill="#28364C" stroke="white" />
      <path d="M24 4L24 12" stroke="white" strokeLinecap="round" />
      <path d="M28 8L20 8" stroke="white" strokeLinecap="round" />
      <path d="M12 17.332L20 17.332" stroke="white" strokeLinecap="round" />
      <path d="M12 12L17.3333 12" stroke="white" strokeLinecap="round" />
      <path d="M12 22.668L17.3333 22.668" stroke="white" strokeLinecap="round" />
    </svg>
  );
};

ProjectIcon.defaultProps = {
  className: '',
  width: 32,
  height: 32,
};

export default ProjectIcon;
